export default "__VITE_ASSET__362a01f0__"